// extracted by mini-css-extract-plugin
module.exports = {"emptyStateBottomPadding":"AmendmentsCard__emptyStateBottomPadding___ajVFX","root":"AmendmentsCard__root___CTbeR"};